export const SET_DATA = 'loadingState/SET_DATA';
export const SET_LOADING = 'loadingState/SET_LOADING';
